<template>
  <div>
    <v-flex>
      <v-layout wrap justify-space-between v-if="!showComponent">
        <v-flex xs5 mb-3 mr-md-0 mr-3>
          <h3 class="font-weight-medium display-30 mb-3">
            {{ t('titles.candidates.jobsBasketTitle') }} ({{ JobBasketSize }})
          </h3>
        </v-flex>
      </v-layout>
    </v-flex>

    <Spinner v-if="showComponent" />

    <v-form v-model="formBasketModel" class="px-2">
      <v-layout v-if="isLogged" mb-4>
        <v-flex id="selectAllcheck" class="flex-center">
          <v-checkbox
            v-if="!showComponent && items && items.length > 0"
            v-model="selectAll"
            hide-details
            label="סימון כל המשרות "
            class="rtl dr-checkbox ma-0"
            :class="{ indeterminate: selectFew }"
            color="orange"
          />
        </v-flex>

        <v-flex
          v-show="!isMobile ? true : isMobile && jobsToSend && jobsToSend.length > 0"
          id="send-cv-to-all"
          text-left
        >
          <DrBtn
            :btn-enabled="jobsToSend && jobsToSend.length == 0 ? true : false"
            type-btn="  send-all-cv-btn   view-on-submit ma-0"
            :action="sendCV"
          >
            <v-icon left ma-0 ml-2>icon-Email</v-icon>
            {{ t(`titles.candidates.sendToAllJobsBtn`) }}
          </DrBtn>
        </v-flex>
      </v-layout>
      <v-list
        v-for="(item, i) in items"
        :key="i"
        class="pt-0 pb-6 jobList_vacancy"
        :class="`checkbox${item.Code}`"
      >
        <v-layout v-if="i === 9" mb-4 text-center>
          <v-flex class="inner_banner">
            <client-only>
              <GptAd
                class="resultsBanner_jobs"
                :ad-unit="dfpToShow.dfpID"
                :is-responsive="true"
                :size="dfpToShow.dfpSize"
              />
            </client-only>
          </v-flex>
        </v-layout>
        <v-layout
          class="job-select-box"
          :class="{ selected: jobBasketModel[i] }"
        >
          <v-flex v-if="isLogged" xs1 text-center class="flex-center">
            <v-checkbox
              :id="`checkbox${item.Code}`"
              v-model="jobBasketModel"
              hide-details
              :value="item"
              class="rtl pa-0 dr-checkbox ma-0 justify-center"
              color="orange"
            />
          </v-flex>

          <v-flex :class="isLogged ? 'xs11' : 'xs12'">
            <JobItem
              :job-details="item"
              :recomended-job="item.JobInfo.IsRecommender"
              class="job-item"
              :is-single-job="false"
              :display-cv-btn="true"
              :ssasource="3"
              :job-index="i"
              :showRank="isLogged"
            />
          </v-flex>
        </v-layout>
      </v-list>
    </v-form>

    <v-layout v-show="emptyMsg" column justify-center text-center>
      <v-flex>
        <h3 class="display-24 mb-2">סל המשרות שלך ריק</h3>

        <h3 class="display-22">
          להוספת משרות היכנסו למשרה ולחצו על ה-
          <v-icon
            right
            primary--color
            class="icon-like-on mx-1"
            color="primary"
          />
          והמשרה תתווסף לסל.
        </h3>
      </v-flex>
    </v-layout>
    <CVsJobBasket :jobs-to-send="jobsToSend" />
  </div>
</template>

<script>
import jobBasketBaseVue from './mixins/jobBasketBase.vue';
import CVsJobBasket from '@/components/Dialogs/CvsJobBasket/CVsJobBasket';
import CurrentUser from '@/components/mixins/CurrentUser';
import { API_URL } from '@/lib/api.js';

export default {
  mixins: [jobBasketBaseVue, CurrentUser],
  components: {
    CVsJobBasket,
  },

  data() {
    return {
      API_URL,
      status: 1,
    };
  },
};
</script>
